import type { IChildInfo } from '../../../../../pages/common';
import type { IIntakeQuestionnaireDetails } from '../../types';

// Same as ensureIntakeFamily: background/schedule creates return only the new row, so initialize
// child_info (and null list fields) instead of dropping the row. id is unused in the UI.
export function ensureIntakeChildInfo(details: IIntakeQuestionnaireDetails): IChildInfo {
  if (!details.child_info) {
    details.child_info = {
      id: 0,
      child_behavior_issues: null,
      backgrounds: [],
      schedule: [],
    };
    return details.child_info;
  }
  details.child_info.backgrounds ??= [];
  details.child_info.schedule ??= [];
  return details.child_info;
}
